import { render, staticRenderFns } from "./FollowProtocol.vue?vue&type=template&id=0150c636&"
import script from "./FollowProtocol.vue?vue&type=script&lang=js&"
export * from "./FollowProtocol.vue?vue&type=script&lang=js&"
import style0 from "./FollowProtocol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports